import { useCallback, useRef } from 'react';

import PropTypes from 'prop-types';

import useWindowSize from '#client/hooks/useWindowSize';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks';

import { CarouselContainer, CarouselContent } from './Carousel.styles';
import { CarouselControls } from './CarouselControls';

export const Carousel = ({ children, onBack, onNext }) => {
  const getScrollbarWidth = useCallback(
    () => window.innerWidth - document.documentElement.clientWidth,
    []
  );

  const carouselRef = useRef(null);
  const [width] = useWindowSize();
  const widthWithoutScrollbar = width - getScrollbarWidth();

  const { sizes: { isPC } } = useBreakpoints();

  return (
    <CarouselContainer aria-label="carousel">
      <CarouselContent windowWidth={widthWithoutScrollbar} ref={carouselRef}>
        {children}
      </CarouselContent>
      {isPC && <CarouselControls carouselRef={carouselRef} onBack={onBack} onNext={onNext} />}
    </CarouselContainer>
  );
};

Carousel.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func
};

Carousel.defaultProps = {
  onNext: () => {},
  onBack: () => {}
};
